
import { createStore } from 'vuex'
import createdPersistedState from "vuex-persistedstate"

export default createStore({
  state: {
    userId:"",
    companyId:"",
    chatId:"",
    systemAccess:{}
  },
  getters:{
    getUserId(state){
      return state.userId
    },
    getCompanyId(state){
      return state.companyId
    },
    getSystemAccess(state){
      return state.systemAccess
    }
  },
  mutations: {
    addUserId(state, data){
      state.userId = data
    },
    addCompanyId(state, data){
      state.companyId = data
    },
    addSystemAccess(state, data){
      state.systemAccess = data;
    }
  },
  actions: {
  },
  modules: {
  },
  plugins:[createdPersistedState()]
})
